export interface U3141UseDownloadHistoriqueCadastralHtmlHandlersParams {
  doGetCadastralHistoryDocumentUrlFn: (masterLotChainId: string) => Promise<{ data?: { signUrl?: string; result?: { signUrl?: string } } }>;
  onSuccess?: (signUrl: string) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseDownloadHistoriqueCadastralHtmlHandlersReturn {
  downloadHistoriqueCadastralHtml: (masterLotChainId: string) => Promise<void>;
}

export function useU3141UseDownloadHistoriqueCadastralHtmlHandlers({
  doGetCadastralHistoryDocumentUrlFn,
  onSuccess,
  onError,
}: U3141UseDownloadHistoriqueCadastralHtmlHandlersParams): U3141UseDownloadHistoriqueCadastralHtmlHandlersReturn {
  const downloadHistoriqueCadastralHtml = async (masterLotChainId: string) => {
    try {
      const res = await doGetCadastralHistoryDocumentUrlFn(masterLotChainId);
      const data = res.data as { signUrl?: string; result?: { signUrl?: string } } | undefined;
      const signUrl = data?.signUrl ?? data?.result?.signUrl;

      if (signUrl && onSuccess) {
        onSuccess(signUrl);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { downloadHistoriqueCadastralHtml };
}
